// extracted by mini-css-extract-plugin
export var readonly = "_dx-1";
export var star = "_dx-0";